import { Text, Divider, ContextMenuAction } from '@wix/wix-base-ui';
import React from 'react';
import styles from './limitlessZoomMenu.scss';
import { translate } from '#packages/i18n';
import { browserUtil } from '@/util';

const ZOOM_MENU_OPTIONS = [50, 75, 100];

interface LimitlessZoomMenuProps {
  updateZoomPercentage: (requestedZoomPrecentage: number) => void;
  increaseZoomPercentageBy10: () => void;
  decreaseZoomPercentageBy10: () => void;
  fitToScreen?: () => void;
}
const LimitlessZoomMenu = ({
  updateZoomPercentage,
  increaseZoomPercentageBy10,
  decreaseZoomPercentageBy10,
  fitToScreen,
}: LimitlessZoomMenuProps) => {
  return (
    <>
      {fitToScreen && (
        <>
          <ContextMenuAction
            className={styles.menuRow}
            onClick={() => fitToScreen()}
          >
            <Text size="small">Topbar_limitless_zoom_dropdown_fit_label</Text>
            <Text size="small">
              {browserUtil.isMacintosh()
                ? 'Topbar_limitless_zoom_dropdown_fit_shortcut_mac'
                : 'Topbar_limitless_zoom_dropdown_fit_shortcut_windows'}
            </Text>
          </ContextMenuAction>
          <Divider
            className={styles.divider}
            direction="horizontal"
            long={true}
          />
        </>
      )}
      {ZOOM_MENU_OPTIONS.map((zoomPercentage) => (
        <ContextMenuAction
          className={styles.menuRow}
          onClick={() => updateZoomPercentage(zoomPercentage)}
        >
          <Text size="small" shouldTranslate={false}>
            {zoomPercentage}%
          </Text>
          {zoomPercentage === 100 && (
            <Text size="small">
              {browserUtil.isMacintosh()
                ? 'Topbar_limitless_zoom_dropdown_100_shortcut_mac'
                : 'Topbar_limitless_zoom_dropdown_100_shortcut_windows'}
            </Text>
          )}
        </ContextMenuAction>
      ))}
      <Divider className={styles.divider} direction="horizontal" long={true} />
      <ContextMenuAction
        className={styles.menuRow}
        onClick={() => increaseZoomPercentageBy10()}
      >
        <Text size="small">Topbar_limitless_zoom_dropdown_zoomin_label</Text>
        <span className={styles.shortcut}>
          {browserUtil.isMacintosh()
            ? translate('Topbar_limitless_zoom_dropdown_zoomin_shortcut_mac')
            : translate(
                'Topbar_limitless_zoom_dropdown_zoomin_shortcut_windows',
              )}
        </span>
      </ContextMenuAction>
      <ContextMenuAction
        className={styles.menuRow}
        onClick={() => decreaseZoomPercentageBy10()}
      >
        <Text size="small">Topbar_limitless_zoom_dropdown_zoomout_label</Text>
        <span className={styles.shortcut}>
          {browserUtil.isMacintosh()
            ? translate('Topbar_limitless_zoom_dropdown_zoomout_shortcut_mac')
            : translate(
                'Topbar_limitless_zoom_dropdown_zoomout_shortcut_windows',
              )}
        </span>
      </ContextMenuAction>
    </>
  );
};

export default LimitlessZoomMenu;
